// extracted by mini-css-extract-plugin
export default {"leftBar":"bar_leftBar__3IGWJ","rightBar":"bar_rightBar__4wHSJ"};